import React from 'react';
import { DeepAnalysisResult } from '@/types/analysisTypes';
import { Brain } from 'lucide-react';

interface AIReadinessScoreBlockProps {
  pageAnalysisResult: DeepAnalysisResult;
}

export const AIReadinessScoreBlock: React.FC<AIReadinessScoreBlockProps> = ({
  pageAnalysisResult
}) => {
  // Safety check
  if (!pageAnalysisResult?.category_scores) {
    return null;
  }

  // Extract AI Readiness score from either key
  const categoryScores = pageAnalysisResult.category_scores;
  const aiScore = categoryScores["ai_readiness_proxy"] || categoryScores["ai_optimization_score"];
  
  // Get numeric value
  let score = 0;
  if (typeof aiScore === 'number') {
    score = aiScore;
  } else if (typeof aiScore === 'object' && aiScore?.score !== undefined) {
    score = aiScore.score;
  }

  // Only render if we have a valid score
  if (!Number.isFinite(score)) {
    return null;
  }

  return (
    <div className="glass-panel p-4 rounded-lg">
      <div className="flex justify-between items-center mb-2">
        <div className="flex items-center gap-2">
          <Brain className="h-4 w-4" />
          <h5 className="font-medium">AI Readiness</h5>
        </div>
        <span className="font-medium">{score}/20</span>
      </div>
      <p className="text-sm text-muted-foreground">
        How well content is optimized for AI processing and indexing
      </p>
    </div>
  );
};